import { ITEM_ID_SEIZURE, ITEM_ID_SHORT_SEIZURE } from '@lmc/common/types'

export const isSeizureItemLog = (id?: string) =>
  !!id && [ITEM_ID_SEIZURE, ITEM_ID_SHORT_SEIZURE]?.includes(id)
